import StateRule from '@/components/listGeneration/query/ruleSuffix/StateRule';
import IntRule from '@/components/listGeneration/query/ruleSuffix/IntRule';
import FloatRule from '@/components/listGeneration/query/ruleSuffix/FloatRule';
import BoolRule from '@/components/listGeneration/query/ruleSuffix/BoolRule';
import TextRule from '@/components/listGeneration/query/ruleSuffix/TextRule';
import DateRule from '@/components/listGeneration/query/ruleSuffix/DateRule';
import TopIssueRule from '@/components/listGeneration/query/ruleSuffix/TopIssueRule';
import GenderRule from '@/components/listGeneration/query/ruleSuffix/GenderRule';
import RuralRule from '@/components/listGeneration/query/ruleSuffix/RuralRule';
import DonationBasketRule from '@/components/listGeneration/query/ruleSuffix/DonationBasketRule';
import DistinctDonationsBasketRule from '@/components/listGeneration/query/ruleSuffix/DistinctDonationsBasketRule';
import DemographicBasketRule from '@/components/listGeneration/query/ruleSuffix/DemographicBasketRule';
import TimezoneRule from '@/components/listGeneration/query/ruleSuffix/TimezoneRule';
import { StandardBaskets } from '@/store/baskets';

export const ValidListNameChars = /^[a-zA-Z_0-9]*$/;
export const ValidClientTableNameChars = /^[a-z_0-9]*$/;

export const TargetOfficeOptions = [
    { key: 1, name: 'House (1)' },
    { key: 2, name: 'Senate (2)' },
    { key: 3, name: 'Issue (3)' },
    { key: 4, name: 'Statewide (4)' },
    { key: 5, name: 'Citywide (5)' },
    { key: 6, name: 'Presidential (6)' },
    { key: 7, name: 'Party (7)' },
];

export const States = [
    { type: 'state', key: 'AL', name: 'Alabama' },
    { type: 'state', key: 'AK', name: 'Alaska' },
    { type: 'state', key: 'AS', name: 'American Samoa' },
    { type: 'state', key: 'AZ', name: 'Arizona' },
    { type: 'state', key: 'AR', name: 'Arkansas' },
    { type: 'state', key: 'CA', name: 'California' },
    { type: 'state', key: 'CO', name: 'Colorado' },
    { type: 'state', key: 'CT', name: 'Connecticut' },
    { type: 'state', key: 'DE', name: 'Delaware' },
    { type: 'state', key: 'DC', name: 'District of Columbia' },
    { type: 'state', key: 'FM', name: 'Federated States of Micronesia' },
    { type: 'state', key: 'FL', name: 'Florida' },
    { type: 'state', key: 'GA', name: 'Georgia' },
    { type: 'state', key: 'GU', name: 'Guam' },
    { type: 'state', key: 'HI', name: 'Hawaii' },
    { type: 'state', key: 'ID', name: 'Idaho' },
    { type: 'state', key: 'IL', name: 'Illinois' },
    { type: 'state', key: 'IN', name: 'Indiana' },
    { type: 'state', key: 'IA', name: 'Iowa' },
    { type: 'state', key: 'KS', name: 'Kansas' },
    { type: 'state', key: 'KY', name: 'Kentucky' },
    { type: 'state', key: 'LA', name: 'Louisiana' },
    { type: 'state', key: 'ME', name: 'Maine' },
    { type: 'state', key: 'MH', name: 'Marshall Islands' },
    { type: 'state', key: 'MD', name: 'Maryland' },
    { type: 'state', key: 'MA', name: 'Massachusetts' },
    { type: 'state', key: 'MI', name: 'Michigan' },
    { type: 'state', key: 'MN', name: 'Minnesota' },
    { type: 'state', key: 'MS', name: 'Mississippi' },
    { type: 'state', key: 'MO', name: 'Missouri' },
    { type: 'state', key: 'MT', name: 'Montana' },
    { type: 'state', key: 'NE', name: 'Nebraska' },
    { type: 'state', key: 'NV', name: 'Nevada' },
    { type: 'state', key: 'NH', name: 'New Hampshire' },
    { type: 'state', key: 'NJ', name: 'New Jersey' },
    { type: 'state', key: 'NM', name: 'New Mexico' },
    { type: 'state', key: 'NY', name: 'New York' },
    { type: 'state', key: 'NC', name: 'North Carolina' },
    { type: 'state', key: 'ND', name: 'North Dakota' },
    { type: 'state', key: 'MP', name: 'Northern Mariana Islands' },
    { type: 'state', key: 'OH', name: 'Ohio' },
    { type: 'state', key: 'OK', name: 'Oklahoma' },
    { type: 'state', key: 'OR', name: 'Oregon' },
    { type: 'state', key: 'PW', name: 'Palau' },
    { type: 'state', key: 'PA', name: 'Pennsylvania' },
    { type: 'state', key: 'PR', name: 'Puerto Rico' },
    { type: 'state', key: 'RI', name: 'Rhode Island' },
    { type: 'state', key: 'SC', name: 'South Carolina' },
    { type: 'state', key: 'SD', name: 'South Dakota' },
    { type: 'state', key: 'TN', name: 'Tennessee' },
    { type: 'state', key: 'TX', name: 'Texas' },
    { type: 'state', key: 'UT', name: 'Utah' },
    { type: 'state', key: 'VT', name: 'Vermont' },
    { type: 'state', key: 'VI', name: 'Virgin Islands' },
    { type: 'state', key: 'VA', name: 'Virginia' },
    { type: 'state', key: 'WA', name: 'Washington' },
    { type: 'state', key: 'WV', name: 'West Virginia' },
    { type: 'state', key: 'WI', name: 'Wisconsin' },
    { type: 'state', key: 'WY', name: 'Wyoming' },
];

export const Timezones = [
    { name: 'EST', key: 'EST', type: 'timezone' },
    { name: 'PST', key: 'PST', type: 'timezone' },
    { name: 'CST', key: 'CST', type: 'timezone' },
    { name: 'MST', key: 'MST', type: 'timezone' },
    { name: 'AKST', key: 'AKST', type: 'timezone' },
    { name: 'HST', key: 'HST', type: 'timezone' },
];

export const AdditionalColumnOptions = [
    { name: 'abx', desc: 'donor has an act blue express account' },
    { name: 'active_email_percentile', desc: "donor's percentile [0.0 to 1.0] for email activity among all donors" },
    {
        name: 'active_email_rank',
        desc: "donor's rank for email activity among all donors (1 is most active). Required to sort by this field.",
    },
    {
        name: 'active_email_score',
        desc: "Measures how engaged a person is with email outreach, on a scale of 0-10. It sums up factors such as whether they've donated to email before, how recently they clicked or opened an email, and their click and open rate. A score of 0 means we found no email history for this person. Active_email_rank and active_email_percentile can be used to find who is more or less active relative to others with known email history.",
    },
    { name: 'active_mail_percentile', desc: "donor's percentile [0.0 to 1.0] for mail activity among all donors" },
    {
        name: 'active_mail_rank',
        desc: "donor's rank for mail activity among all donors (1 is most active). Required to sort by this field.",
    },
    { name: 'active_mail_score', desc: 'score based on mail exhaust data; scale 0-10' },
    { name: 'active_mobile_percentile', desc: "donor's percentile [0.0 to 1.0] for mobile activity among all donors" },
    {
        name: 'active_mobile_rank',
        desc: "donor's rank for mobile activity among all donors (1 is most active). Required to sort by this field.",
    },
    {
        name: 'active_mobile_score',
        desc: "Measures how engaged a person is with mobile/text outreach, on a scale of 0-10. It sums up factors such as whether they've donated through text before, how recently they were texted, and whether they have opted in or out of texts. A score of 0 means we found no mobile history for this person. Active_mobile_rank and active_mobile_percentile can be used to find who is more or less active relative to others with known mobile history.",
    },
    {
        name: 'active_messenger_percentile',
        desc: "donor's percentile [0.0 to 1.0] for messenger activity among all donors",
    },
    {
        name: 'active_messenger_rank',
        desc: "donor's rank for messenger activity among all donors (1 is most active). Required to sort by this field.",
    },
    {
        name: 'active_messenger_score',
        desc: "Measures how engaged a person is with Meta/Facebook messaging outreach, on a scale of 0-10. It sums up factors such as how recently they donated through Meta/Facebook messenger and whether they've given on a mobile device. A score of 0 means we've found no Meta/Facebook messenger donation history. Active_messenger_rank and active_messenger_percentile can be used to find who is more or less active relative to others with known messenger history.",
    },
    {
        name: 'active_nonprofit_mobile_percentile',
        desc: "donor's percentile [0.0 to 1.0] for mobile activity among all donors to nonprofits",
    },
    {
        name: 'active_nonprofit_mobile_rank',
        desc: "donor's rank for mobile activity among all donors to nonprofits (1 is most active). Required to sort by this field.",
    },
    {
        name: 'active_nonprofit_mobile_score',
        desc: '0-10 score of how active a mobile number is among donors to nonprofits',
    },
    { name: 'attorney_general_sum', desc: 'number of donations to attorney general races' },
    { name: 'avg_click_rate', desc: 'number of emails / number of clicks' },
    { name: 'avg_open_rate', desc: 'number of emails / number of opens' },
    { name: 'avg_unsub_rate', desc: 'percentage of emails a person unsubscribes to' },
    { name: 'ballot_initiative_sum', desc: 'number of ballot initiatives an donor has financially supported' },
    { name: 'bounced', desc: 'email bounced' },
    { name: 'cc_exclude', desc: 'email is exclusive to memebers of the click collective' },
    { name: 'citywide_cand_string', desc: 'uppercase citywide donations' },
    { name: 'citywide_contribution_avg', desc: 'average City-level contribution size' },
    {
        name: 'citywide_multistate_sum',
        desc: 'number of different states a donor has given to a city-level candidate in',
    },
    { name: 'contribution_avg', desc: 'average contribution amount' },
    { name: 'contribution_max', desc: 'highest contribution amount' },
    { name: 'contributions_afam', desc: 'number of donations to afam candidates' },
    { name: 'contributions_asianam', desc: 'number of donations to asian-american candidates' },
    { name: 'contributions_bernie', desc: 'number of donations to progressive candidates' },
    { name: 'contributions_challenger', desc: 'number of donations to challengers' },
    { name: 'contributions_gender', desc: 'number of donations to women candidates' },
    { name: 'contributions_incumbent', desc: 'number of donations to incumbents' },
    { name: 'contributions_jewish', desc: 'number of donations to jewish candidates' },
    { name: 'contributions_latino', desc: 'number of donations to latino candidates' },
    { name: 'contributions_lgbtq', desc: 'number of donations to LGBTQ candidates' },
    { name: 'contributions_muslim', desc: 'number of donations to muslim candidates' },
    { name: 'contributions_open', desc: 'number of donations to people running in open seats' },
    { name: 'contributions_primary', desc: 'number of donations to people running in primaries' },
    { name: 'contributions_under40', desc: 'number of donations to candidates under 40 years old' },
    { name: 'contributor', desc: 'name, city, and state of a donor (unique ID)' },
    { name: 'contributor_age', desc: 'donor age' },
    { name: 'contributor_dob', desc: 'donor date of birth' },
    { name: 'conversion_rate_email', desc: 'emails sent / emails donated to' },
    { name: 'conversion_rate_p2p', desc: 'number of texts / number of gifts' },
    { name: 'countyname', desc: 'county of residence' },
    { name: 'date1', desc: 'most recent date of donation' },
    { name: 'days_at_current_address', desc: 'number of days someone has lived at their current address' },
    { name: 'days_since_given_by_email', desc: 'number of days since last email donation' },
    {
        name: 'days_since_given_by_tagged_text',
        desc: 'number of days since a donation was made in response to a known text with a refcode',
    },
    { name: 'days_since_v_address', desc: 'number of days since an address has been verified' },
    { name: 'democrat_sum', desc: 'number of donations to dems' },
    { name: 'digital_ad_conversions', desc: 'number of donations made through digital ads' },
    { name: 'early_donor', desc: 'Made a donation to a campaign launch' },
    { name: 'email_donation_average', desc: 'donors average email gift' },
    { name: 'email_origin', desc: 'how GA received the email' },
    { name: 'email_per_day_index', desc: 'estimated number of emails a donor recieves in one day' },
    { name: 'emailablemxrecord', desc: 'domain from emailable' },
    { name: 'emailablescore', desc: 'emailable score' },
    { name: 'employer', desc: 'donor employer' },
    { name: 'federalcand_sum', desc: 'number of federal candidate donations' },
    { name: 'firsttime_candidate_sum', desc: 'number of 1st time candidates someone has given to' },
    { name: 'gave_on_mobiledevice', desc: 'made a donation from a smartphone' },
    { name: 'gov_donation_sum', desc: 'number of donations to gubnatorial races' },
    { name: 'house_cand_string', desc: 'lowercase House donations' },
    { name: 'house_contribution_avg', desc: 'average House contribution size' },
    { name: 'house_contribution_max', desc: 'highest contribution to a House race' },
    { name: 'house_multistate_sum', desc: 'number of different states a donor has given to a house candidate in' },
    { name: 'house_sum', desc: 'number of House donations' },
    { name: 'investment_cand_string', desc: 'string of all investments a person has made' },
    { name: 'investment_sum', desc: 'number of investments a person has made' },
    { name: 'issue_cand_string', desc: 'lowercase for federal pacs and uppercase for state pacs' },
    { name: 'issue_contribution_avg', desc: 'average PAC/Nonprofit contribution size' },
    { name: 'last_dem_amount', desc: 'amount given to last dem' },
    { name: 'last_dem_date', desc: 'date of last dem donation' },
    { name: 'last_gop_amount', desc: 'amount of last gop donation' },
    { name: 'last_gop_date', desc: 'date of last gop donation' },
    { name: 'linkedin_url', desc: 'donor linkedin profile' },
    { name: 'messenger_conversions', desc: 'number of donations made through Facebook messenger' },
    { name: 'mobile_opt_in', desc: 'opted in to receive texts from one of our clients' },
    { name: 'mobile_per_day_index', desc: 'intermediate variable, I would disregard' },
    { name: 'most_old_email_date', desc: 'first time an email was imported' },
    { name: 'mobile_origin', desc: 'how GA received the mobile number. Not compatible with legacy data.' },
    { name: 'modeled_ad_conversions', desc: 'modeled ads donations based on new and improved formula' },
    { name: 'modeled_mail_conversions', desc: 'mail donations based on new and improved formula' },
    { name: 'modeled_text_conversions', desc: 'modeled text donations based on new and improved formula' },
    { name: 'most_recent_click', desc: 'last click date' },
    { name: 'most_recent_email_date', desc: 'most recent time an email has been imported' },
    { name: 'most_recent_open', desc: 'last open date' },
    { name: 'net_worth', desc: 'estimated networth 0 - infinity' },
    { name: 'non_abx_online', desc: 'true when a donor has given online somewhere other than ActBlue' },
    { name: 'nonprofit_cand_string', desc: 'uppercase nonprofit donations' },
    { name: 'nonprofit_contribution_max', desc: 'max donation to a nonprofit' },
    { name: 'number_of_donations', desc: 'number of donations made' },
    { name: 'occupation', desc: 'donor occupation' },
    {
        name: 'path2response_tier',
        desc: 'A score from Path2Response. This is mainly used to show someone actually has donated through mail. The scores are meaningless.',
    },
    {
        name: 'p2p_actblue_dislike_count',
        desc: 'number of inbound P2P replies where someone said they dislike ActBlue',
    },
    { name: 'p2p_average_opt_out_rate', desc: 'number of texts / number of opt outs' },
    { name: 'p2p_average_support_rate', desc: 'number of texts / donations or message of support' },
    { name: 'p2p_cand_conv_string', desc: 'who someone has donated to over p2p ' },
    { name: 'p2p_date_of_last_text', desc: 'number of p2p donations' },
    { name: 'p2p_text_count', desc: 'number of times someone has been texted' },
    { name: 'pac_cand_string', desc: 'donors pac donations' },
    { name: 'pac_contribution_avg', desc: 'avg gift to pacs' },
    { name: 'pac_contribution_max', desc: 'max donation to a pac' },
    { name: 'pac_contribution_sum', desc: 'total donation amount to pacs' },
    { name: 'party_cand_string', desc: 'lowercase Party donations' },
    { name: 'party_contribution_avg', desc: 'average Party contribution size' },
    { name: 'political_max', desc: 'highest contribution amount made to any political campaign or organization' },
    { name: 'possible_spanish_speaker', desc: 'likely spanish speaker' },
    { name: 'potential_mail_donor', desc: 'modeled likelihood that a donor would give through mail' },
    { name: 'presidential_cand_string', desc: 'lowercase presidential donations' },
    { name: 'presidential_sum', desc: 'number of Presidential donations' },
    { name: 'reason_to_give', desc: 'donors topissues (see top issue tab)' },
    { name: 'recurring_donation_count', desc: 'number of recurring donations made' },
    { name: 'recurring', desc: 'a person has signed up to give a recurring gift to some candidate' },
    { name: 'republican_sum', desc: 'number of donations to gop' },
    {
        name: 'risk_ratio',
        desc: 'The ratio of unsubscribes to clicks, capped at 10. If clicks are 0 but there are unsubs, it forces 10 (max risk). If both are 0/null, it defaults to 1 (neutral). If risk_ratio > 1, the user unsubs more often than they click. If risk_ratio < 1, the user clicks more often than they unsub.',
    },
    { name: 'runoff_contributions', desc: 'number of contributions to races in a runoff' },
    { name: 'rural_count', desc: 'number of donations made to rural districts' },
    { name: 'rural_house_count', desc: 'number of donations made to rural House districts' },
    { name: 'senate_cand_string', desc: 'lowercase Senate donations' },
    { name: 'senate_contribution_avg', desc: 'average Senate contribution size' },
    { name: 'senate_contribution_max', desc: 'highest contribution to a Senate race' },
    { name: 'senate_sum', desc: 'number of Senate donations' },
    { name: 'simple_dem', desc: 'brief version' },
    { name: 'sms_count', desc: 'number of SMS messages sent' },
    { name: 'mms_count', desc: 'number of MMS messages sent' },
    { name: 'p2p_text_count_30d', desc: 'number of P2P text messages sent in the past 30 days' },
    { name: 'shares_email_30d', desc: 'number of times an email has been sold in the past 30 days' },
    { name: 'state_sum', desc: 'number of candidate states that a donor has given in' },
    { name: 'statewide_cand_string', desc: 'uppercase state-level donations' },
    { name: 'statewide_contribution_avg', desc: 'average State-level contribution size' },
    { name: 'statewide_contribution_max', desc: 'highest contribution to a State-level race' },
    {
        name: 'statewide_multistate_sum',
        desc: 'number of different states a donor has given to a state-level candidate in',
    },
    { name: 'suburban_count', desc: 'number of donations made to suburban districts' },
    { name: 'suburban_house_count', desc: 'number of donations made to suburban House districts' },
    { name: 'sum_pvi', desc: 'number of donations made to deep red districts' },
    { name: 'tagged_text_donation_average', desc: 'average donation amount from known texts with a tagged refcode' },
    { name: 'timezone', desc: 'US standard timezone' },
    { name: 'top_donor_state', desc: 'Donor top state formatted in all caps (e.g. NY)' },
    { name: 'tw_digital_ad_conversion', desc: 'how many digital ad conversions in the past year' },
    { name: 'tw_email_conversions', desc: 'how many email conversions in the past year' },
    { name: 'tw_mobile_conversions', desc: 'time weighted mobile donations' },
    { name: 'tw_modeled_mail_conversion', desc: 'time weighted modeled mail conversions' },
    { name: 'twitter_handle', desc: 'twitter username' },
    { name: 'unlimited_recurring', desc: 'signed up for unlimited recurring gifts on ActBlue' },
    { name: 'urban_count', desc: 'number of donations made to urban districts' },
    { name: 'urban_house_count', desc: 'number of donations made to urban House districts' },
    { name: 'used_to_work', desc: 'all caps previous employer (OLIVE GARDEN)' },
    {
        name: 'vbvoterbase_mover_status',
        desc: 'categorical variable which indicates if someone lives at the listed address',
    },
    { name: 'years_in_db', desc: 'how many years have we had this person in the Database' },
];

export const TopIssues = [
    { type: 'topissue', key: 'topissue_ada', name: 'topissue_ada', desc: 'donates to disability rights causes' },
    { type: 'topissue', key: 'topissue_afam', name: 'topissue_afam', desc: 'supports African American candidates' },
    { type: 'topissue', name: 'topissue_AIPAC', key: 'topissue_AIPAC', desc: 'supports AIPAC/AIPAC candidates' },
    {
        type: 'topissue',
        name: 'topissue_animals',
        key: 'topissue_animals',
        desc: 'gives to animal welfare efforts (shelters/conservation etc)',
    },
    {
        type: 'topissue',
        key: 'topissue_arts',
        name: 'topissue_arts',
        desc: 'supports the arts / donates to museums etc',
    },
    { type: 'topissue', name: 'topissue_asianam', key: 'topissue_asianam', desc: 'supports Asian American candidates' },
    {
        type: 'topissue',
        key: 'topissue_athletics',
        name: 'topissue_athletics',
        desc: 'supports local athletics clubs/works in the athletic industry',
    },
    { type: 'topissue', name: 'topissue_bernie', key: 'topissue_bernie', desc: 'supports progressive candidates' },
    {
        type: 'topissue',
        name: 'topissue_birthday',
        key: 'topissue_birthday',
        desc: 'engages with content about birthdays (“it’s my birthday”)',
    },
    {
        type: 'topissue',
        key: 'topissue_blm',
        name: 'topissue_blm',
        desc: 'donates to Black Lives Matter causes and affiliated candidates',
    },
    { type: 'topissue', name: 'topissue_blue_dog', key: 'topissue_blue_dog', desc: 'very moderate dems' },
    {
        type: 'topissue',
        name: 'topissue_brady',
        key: 'topissue_brady',
        desc: 'gun control donors with a strong Brady Campaign skew',
    },
    {
        type: 'topissue',
        name: 'topissue_celebrity',
        key: 'topissue_celebrity',
        desc: 'responds to celebrity-endorsed content and appeals',
    },
    { type: 'topissue', name: 'topissue_challenger', key: 'topissue_challenger', desc: 'supports challengers' },
    {
        type: 'topissue',
        name: 'topissue_citywide',
        key: 'topissue_citywide',
        desc: 'supports city-level candidates (city council to mayor)',
    },
    {
        type: 'topissue',
        name: 'topissue_courts',
        key: 'topissue_courts',
        desc: 'motivated by Supreme Court composition and judicial issues',
    },
    {
        type: 'topissue',
        key: 'topissue_crimjust',
        name: 'topissue_crimjust',
        desc: 'supports criminal justice reform/donates to candidates with high crimjust scores',
    },
    {
        type: 'topissue',
        key: 'topissue_deadline',
        name: 'topissue_deadline',
        desc: 'motivated to give during deadlines',
    },
    {
        type: 'topissue',
        key: 'topissue_democracy',
        name: 'topissue_democracy',
        desc: 'motivated by pro-democracy/voting rights',
    },
    {
        type: 'topissue',
        key: 'topissue_disasterrelief',
        name: 'topissue_disasterrelief',
        desc: 'supports disaster relief efforts',
    },
    { type: 'topissue', key: 'topissue_doge', name: 'topissue_doge', desc: 'motivated by anti-Elon/Doge content' },
    { type: 'topissue', key: 'topissue_dsa', name: 'topissue_dsa', desc: 'socialist dems' },
    {
        type: 'topissue',
        key: 'topissue_earthmonth',
        name: 'topissue_earthmonth',
        desc: 'donated during last two Aprils to envirionmental orgs/pacs',
    },
    { type: 'topissue', name: 'topissue_education', key: 'topissue_education', desc: 'donated to Educational causes' },
    {
        type: 'topissue',
        name: 'topissue_electionday',
        key: 'topissue_electionday',
        desc: 'donated only during September to November during election years and not outside that window',
    },
    {
        type: 'topissue',
        key: 'topissue_environment',
        name: 'topissue_environment',
        desc: 'supports environmental groups/candidates with high enviro scores',
    },
    {
        type: 'topissue',
        name: 'topissue_family',
        key: 'topissue_family',
        desc: 'engages with content referring to family members (“my wife” “my son” etc.)',
    },
    {
        type: 'topissue',
        name: 'topissue_firstthennow',
        key: 'topissue_firstthennow',
        desc: 'engages with content that follows a “first ___ then ___ now ___” structure',
    },
    {
        type: 'topissue',
        key: 'topissue_foreignpolicy',
        name: 'topissue_foreignpolicy',
        desc: 'cares about international issues',
    },
    {
        type: 'topissue',
        name: 'topissue_gb_news',
        key: 'topissue_gb_news',
        desc: 'engages with content that follows a “good news bad news” structure',
    },
    { type: 'topissue', name: 'topissue_gender', key: 'topissue_gender', desc: 'supports women candidates' },
    {
        type: 'topissue',
        name: 'topissue_geography',
        key: 'topissue_geography',
        desc: 'focuses their giving in a particular state -- you would not use this variable in particular you would use strpos(reason_to_give,"florida")>0 to find folks who support FL candidates',
    },
    {
        type: 'topissue',
        name: 'topissue_gotv',
        key: 'topissue_gotv',
        desc: 'pro-democracy/getting out the vote efforts',
    },
    { type: 'topissue', name: 'topissue_green_new_deal', key: 'topissue_green_new_deal', desc: 'GND co-sponsors ' },
    { type: 'topissue', name: 'topissue_guns', key: 'topissue_guns', desc: 'gun control supporters' },
    { type: 'topissue', name: 'topissue_house', key: 'topissue_house', desc: 'supports House candidates' },
    { type: 'topissue', name: 'topissue_housing', key: 'topissue_housing', desc: 'supports affordable housing' },
    { type: 'topissue', key: 'topissue_hrc', name: 'topissue_hrc', desc: 'donates to Human Rights Campaign (LGBTQ)' },
    {
        type: 'topissue',
        key: 'topissue_immigration',
        name: 'topissue_immigration',
        desc: 'supports immigration reform/candidates with high immigration scores',
    },
    { type: 'topissue', name: 'topissue_incumbent', key: 'topissue_incumbent', desc: 'supports incumbents' },
    { type: 'topissue', key: 'topissue_issue', name: 'topissue_issue', desc: 'donates to PACs and nonprofits ' },
    { type: 'topissue', name: 'topissue_jewish', key: 'topissue_jewish', desc: 'supports Jewish candidates' },
    { type: 'topissue', name: 'topissue_jstreet', key: 'topissue_jstreet', desc: 'donates to J Street' },
    { type: 'topissue', name: 'topissue_latino', key: 'topissue_latino', desc: 'supports Latino candidates' },
    { type: 'topissue', key: 'topissue_lgbtq', name: 'topissue_lgbtq', desc: 'supports LGBTQ candidates' },
    { type: 'topissue', key: 'topissue_lpac', name: 'topissue_lpac', desc: 'lesbian candidates/causes' },
    { type: 'topissue', name: 'topissue_lweed', key: 'topissue_lweed', desc: 'supports legalizing weed' },
    {
        type: 'topissue',
        key: 'topissue_match',
        name: 'topissue_match',
        desc: 'responds to donation matching tactics',
    },
    { type: 'topissue', key: 'topissue_medical', name: 'topissue_medical', desc: 'supports medical research' },
    {
        type: 'topissue',
        name: 'topissue_membership',
        key: 'topissue_membership',
        desc: 'responds to membership appeals',
    },
    {
        type: 'topissue',
        key: 'topissue_merch',
        name: 'topissue_merch',
        desc: 'has either donated to a merch email/text or has bought political merch',
    },
    { type: 'topissue', key: 'topissue_moderate', name: 'topissue_moderate', desc: 'moderate dems' },
    { type: 'topissue', key: 'topissue_muslim', name: 'topissue_muslim', desc: 'supports Muslim candidates' },
    { type: 'topissue', name: 'topissue_newpolitics', key: 'topissue_newpolitics', desc: 'vet candidates' },
    {
        type: 'topissue',
        name: 'topissue_newsvalidators',
        key: 'topissue_newsvalidators',
        desc: 'responds to news media validators (Rachel Maddow, MSNBC, CNN, etc.)',
    },
    {
        type: 'topissue',
        name: 'topissue_nonprofiteoy',
        key: 'topissue_nonprofiteoy',
        desc: 'gives to non profits around the end of year push',
    },
    {
        type: 'topissue',
        name: 'topissue_obama',
        key: 'topissue_obama',
        desc: 'motivated by Obama mentions and endorsements',
    },
    {
        type: 'topissue',
        name: 'topissue_open',
        key: 'topissue_open',
        desc: 'supports candidates running in open seats',
    },
    {
        type: 'topissue',
        name: 'topissue_othervalidators',
        key: 'topissue_othervalidators',
        desc: 'responds to high profile non-news validators (Mark Ruffalo, Liz Cheney, etc.)',
    },
    { type: 'topissue', name: 'topissue_palestine', key: 'topissue_palestine', desc: 'supports palestine' },
    {
        type: 'topissue',
        key: 'topissue_party',
        name: 'topissue_party',
        desc: 'supports Dem party (DNC, DCCC, DSCC, DGA, or state parties)',
    },
    { type: 'topissue', key: 'topissue_petition', name: 'topissue_petition', desc: 'engages with petition content' },
    { type: 'topissue', name: 'topissue_pets', key: 'topissue_pets', desc: 'engages with content about pets' },
    { type: 'topissue', name: 'topissue_pov_child', key: 'topissue_pov_child', desc: 'gives to fight child poverty' },
    { type: 'topissue', name: 'topissue_pp', key: 'topissue_pp', desc: 'pro choice dems' },
    {
        type: 'topissue',
        key: 'topissue_pridemonth',
        name: 'topissue_pridemonth',
        desc: 'donated during last three Junes to queer orgs/pacs',
    },
    {
        type: 'topissue',
        key: 'topissue_primary',
        name: 'topissue_primary',
        desc: 'supports candidates running in primaries',
    },

    {
        type: 'topissue',
        key: 'topissue_progressive',
        name: 'topissue_progressive',
        desc: 'supports progressive candidates',
    },

    { type: 'topissue', name: 'topissue_psolver', key: 'topissue_psolver', desc: 'very moderate dems' },
    { type: 'topissue', key: 'topissue_pvi', name: 'topissue_pvi', desc: 'supports dems in red seats' },
    {
        type: 'topissue',
        name: 'topissue_recurring',
        key: 'topissue_recurring',
        desc: 'responds to recurring/sustaining donation asks',
    },
    {
        type: 'topissue',
        name: 'topissue_redistrict',
        key: 'topissue_redistrict',
        desc: 'supports redistricting efforts',
    },
    {
        type: 'topissue',
        key: 'topissue_religion',
        name: 'topissue_religion',
        desc: 'donates to a religous institution/ works for a religous instituion',
    },
    {
        type: 'topissue',
        key: 'topissue_safe_seat',
        name: 'topissue_safe_seat',
        desc: 'supports candidates in safe blue seats',
    },
    {
        type: 'topissue',
        key: 'topissue_seditionist',
        name: 'topissue_seditionist',
        desc: 'gives and engages with Jan 6th content',
    },
    { type: 'topissue', name: 'topissue_senate', key: 'topissue_senate', desc: 'supports Senate candidates' },
    {
        type: 'topissue',
        name: 'topissue_statewide',
        key: 'topissue_statewide',
        desc: 'supports state-level candidates (state leg up to Gov)',
    },
    {
        type: 'topissue',
        key: 'topissue_strong_dsa',
        name: 'topissue_strong_dsa',
        desc: 'gives mainly to socialist dems',
    },
    { type: 'topissue', key: 'topissue_survey', name: 'topissue_survey', desc: 'engages with survey content' },
    {
        type: 'topissue',
        name: 'topissue_sus_jstreet',
        key: 'topissue_sus_jstreet',
        desc: 'gives to J Street candidates',
    },
    {
        type: 'topissue',
        key: 'topissue_timebound',
        name: 'topissue_timebound',
        desc: 'engages with content that implies the recommended action won’t take very long (“this will only take a second”)',
    },
    {
        type: 'topissue',
        key: 'topissue_tossup',
        name: 'topissue_tossup',
        desc: 'gives to frontline and red to blue races',
    },
    {
        type: 'topissue',
        key: 'topissue_under40',
        name: 'topissue_under40',
        desc: 'supports candidates under 40 years old',
    },
    {
        type: 'topissue',
        key: 'topissue_unions',
        name: 'topissue_unions',
        desc: 'donated to labor unions/union members/employees',
    },

    {
        type: 'topissue',
        key: 'topissue_veterans',
        name: 'topissue_veterans',
        desc: 'supports vet candidates',
    },

    {
        type: 'topissue',
        key: 'topissue_villain',
        name: 'topissue_villain',
        desc: 'people who oppose high profile republican candidates (ie. Ted Cruz and people like that)',
    },
    { type: 'topissue', key: 'topissue_vote_vets', name: 'topissue_vote_vets', desc: 'vet candidates' },
];

export const SLTopIssues = [
    {
        type: 'sl_topissue',
        key: 'sl_topissue_afam',
        name: 'afam',
        desc: 'engages with subject lines that include african american rights/candidates key words',
    },
    {
        type: 'sl_topissue',
        key: 'sl_topissue_aipac',
        name: 'aipac',
        desc: 'engages with subject lines that include AIPAC key words',
    },
    {
        type: 'sl_topissue',
        key: 'sl_topissue_animals',
        name: 'animals',
        desc: 'engages with subject lines that include animal rights key words',
    },
    {
        type: 'sl_topissue',
        key: 'sl_topissue_arts',
        name: 'arts',
        desc: 'engages with subject lines that include arts key words',
    },
    {
        type: 'sl_topissue',
        key: 'sl_topissue_asianam',
        name: 'asianam',
        desc: 'engages with subject lines that include asian american rights/candidates key words',
    },
    {
        type: 'sl_topissue',
        key: 'sl_topissue_athletics',
        name: 'athletics',
        desc: 'engages with subject lines that include athlectics key words',
    },
    {
        type: 'sl_topissue',
        key: 'sl_topissue_bernie',
        name: 'bernie',
        desc: 'engages with subject lines that include progressive key words',
    },
    {
        type: 'sl_topissue',
        key: 'sl_topissue_birthday',
        name: 'birthday',
        desc: 'engages with subject lines that include birthday key words',
    },
    {
        type: 'sl_topissue',
        key: 'sl_topissue_blm',
        name: 'blm',
        desc: 'engages with subject lines that include black lives matter key words',
    },
    {
        type: 'sl_topissue',
        key: 'sl_topissue_blue_dog',
        name: 'blue_dog',
        desc: 'engages with subject lines that include blue dog candidates (moderates) key words',
    },
    {
        type: 'sl_topissue',
        key: 'sl_topissue_celebrity',
        name: 'celebrity',
        desc: 'engages with subject lines that include celebrity key words',
    },
    {
        type: 'sl_topissue',
        key: 'sl_topissue_challenger',
        name: 'challenger',
        desc: 'engages with subject lines that include challengers key words',
    },
    {
        type: 'sl_topissue',
        key: 'sl_topissue_citywide',
        name: 'citywide',
        desc: 'engages with subject lines that include citywide races key words',
    },
    {
        type: 'sl_topissue',
        key: 'sl_topissue_courts',
        name: 'courts',
        desc: 'engages with subject lines that include Supreme Court key words',
    },
    {
        type: 'sl_topissue',
        key: 'sl_topissue_crimjust',
        name: 'crimjust',
        desc: 'engages with subject lines that include criminal justice key words',
    },
    {
        type: 'sl_topissue',
        key: 'sl_topissue_datacenters',
        name: 'datacenters',
        desc: 'engages with subject lines that include data centers key words',
    },
    {
        type: 'sl_topissue',
        key: 'sl_topissue_deadline',
        name: 'deadline',
        desc: 'engages with subject lines that include deadlines key words',
    },
    {
        type: 'sl_topissue',
        key: 'sl_topissue_democracy',
        name: 'democracy',
        desc: 'engages with pro-democracy and voting rights subject lines',
    },
    {
        type: 'sl_topissue',
        key: 'sl_topissue_disasterrelief',
        name: 'disasterrelief',
        desc: 'engages with subject lines regarding disaster relief efforts',
    },
    {
        type: 'sl_topissue',
        key: 'sl_topissue_doge',
        name: 'doge',
        desc: 'engages with anti-elon/doge subject lines',
    },
    {
        type: 'sl_topissue',
        key: 'sl_topissue_dsa',
        name: 'dsa',
        desc: 'engages with subject lines that include dsa key words',
    },
    {
        type: 'sl_topissue',
        key: 'sl_topissue_economy',
        name: 'economy',
        desc: 'engages with subject lines that include references to the economy',
    },
    {
        type: 'sl_topissue',
        key: 'sl_topissue_education',
        name: 'education',
        desc: 'engages with subject lines that include education policy key words',
    },
    {
        type: 'sl_topissue',
        key: 'sl_topissue_emoji',
        name: 'emoji',
        desc: 'engages with subject lines with emojis in them',
    },
    {
        type: 'sl_topissue',
        key: 'sl_topissue_engagement',
        name: 'engagement',
        desc: 'engages with subject lines that include engagement key words',
    },
    {
        type: 'sl_topissue',
        key: 'sl_topissue_environment',
        name: 'environment',
        desc: 'engages with subject lines that include environmental key words',
    },
    {
        type: 'sl_topissue',
        key: 'sl_topissue_family',
        name: 'family',
        desc: 'engages with subject lines that include family member key words ',
    },
    {
        type: 'sl_topissue',
        key: 'sl_topissue_foreignpolicy',
        name: 'foreignpolicy',
        desc: 'engages with subject lines that include foriegn policy key words',
    },
    {
        type: 'sl_topissue',
        key: 'sl_topissue_firstthennow',
        name: 'firstthennow',
        desc: 'engages with subject lines that include first then now key words',
    },
    {
        type: 'sl_topissue',
        key: 'sl_topissue_gb_news',
        name: 'gb_news',
        desc: 'engages with subject lines that include good news bad news key words',
    },
    {
        type: 'sl_topissue',
        key: 'sl_topissue_gender',
        name: 'gender',
        desc: 'engages with subject lines that include women rights/candidates key words',
    },
    {
        type: 'sl_topissue',
        key: 'sl_topissue_gotv',
        name: 'gotv',
        desc: 'engages with subject lines that include gotv key words',
    },
    {
        type: 'sl_topissue',
        key: 'sl_topissue_green_new_deal',
        name: 'green_new_deal',
        desc: 'engages with subject lines that include green new deal key words',
    },
    {
        type: 'sl_topissue',
        key: 'sl_topissue_guns',
        name: 'guns',
        desc: 'engages with subject lines that include gun control key words',
    },
    {
        type: 'sl_topissue',
        key: 'sl_topissue_history',
        name: 'history',
        desc: 'engages with subject lines that include historical and milestone (Ex. first woman, first asian) key words',
    },
    {
        type: 'sl_topissue',
        key: 'sl_topissue_house',
        name: 'house',
        desc: 'engages with subject lines that include house races key words',
    },
    {
        type: 'sl_topissue',
        key: 'sl_topissue_housing',
        name: 'housing',
        desc: 'engages with subject lines that include affordable housing key words',
    },
    {
        type: 'sl_topissue',
        key: 'sl_topissue_hrc',
        name: 'hrc',
        desc: 'engages with subject lines that include human rights key words',
    },
    {
        type: 'sl_topissue',
        key: 'sl_topissue_ideology',
        name: 'ideology',
        desc: 'engages with subject lines that include progressive key words',
    },
    {
        type: 'sl_topissue',
        key: 'sl_topissue_immigration',
        name: 'immigration',
        desc: 'engages with subject lines that include immigration key words',
    },
    {
        type: 'sl_topissue',
        key: 'sl_topissue_incumbent',
        name: 'incumbent',
        desc: 'engages with subject lines that include incumbent candidates key words',
    },
    {
        type: 'sl_topissue',
        key: 'sl_topissue_issue',
        name: 'issue',
        desc: 'engages with subject lines that include PAC/nonprofits key words',
    },
    {
        type: 'sl_topissue',
        key: 'sl_topissue_jewish',
        name: 'jewish',
        desc: 'engages with subject lines that include jewish rights/candidates key words',
    },
    {
        type: 'sl_topissue',
        key: 'sl_topissue_jstreet',
        name: 'jstreet',
        desc: 'engages with subject lines that include jstreet key words',
    },
    {
        type: 'sl_topissue',
        key: 'sl_topissue_latino',
        name: 'latino',
        desc: 'engages with subject lines that include latino rights/candidates key words',
    },
    {
        type: 'sl_topissue',
        key: 'sl_topissue_launch',
        name: 'launch',
        desc: 'engages with subject lines that refer to launching campaigns ("become a founding donor")',
    },
    {
        type: 'sl_topissue',
        key: 'sl_topissue_lweed',
        name: 'lweed',
        desc: 'engages with subject lines that include legalizing weed key words',
    },
    {
        type: 'sl_topissue',
        key: 'sl_topissue_lgbtq',
        name: 'lgbtq',
        desc: 'engages with subject lines that include lgbtq rights/candidates key words',
    },
    {
        type: 'sl_topissue',
        key: 'sl_topissue_lowdollarask',
        name: 'lowdollarask',
        desc: 'engages with subject lines referring to a small dollar amount (“just $1 can make a difference”)',
    },
    {
        type: 'sl_topissue',
        key: 'sl_topissue_lpac',
        name: 'lpac',
        desc: 'engages with subject lines that include lesbian rights/candidates key words',
    },
    {
        type: 'sl_topissue',
        key: 'sl_topissue_match',
        name: 'match',
        desc: 'engages with subject lines containing donation matching tactics',
    },
    {
        type: 'sl_topissue',
        key: 'sl_topissue_medical',
        name: 'medical',
        desc: 'engages with subject lines that include medical research key words',
    },
    {
        type: 'sl_topissue',
        key: 'sl_topissue_moderate',
        name: 'moderate',
        desc: 'engages with subject lines that include moderate key words',
    },
    {
        type: 'sl_topissue',
        key: 'sl_topissue_muslim',
        name: 'muslim',
        desc: 'engages with subject lines that include muslim rights/candidates key words',
    },
    {
        type: 'sl_topissue',
        key: 'sl_topissue_newpolitics',
        name: 'newpolitics',
        desc: 'engages with subject lines that include new politics candidates (vets) key words',
    },
    {
        type: 'sl_topissue',
        key: 'sl_topissue_newsvalidators',
        name: 'newsvalidators',
        desc: 'engages with subject lines that include people in the media (Rachel Maddox, MSNBC,CNN)',
    },
    {
        type: 'sl_topissue',
        key: 'sl_topissue_nonprofiteoy',
        name: 'nonprofiteoy',
        desc: 'engages with subject lines that include giving to non profits around the end of year push key words',
    },
    {
        type: 'sl_topissue',
        key: 'sl_topissue_obama',
        name: 'obama',
        desc: 'engages with subject lines that include Obama key words',
    },
    {
        type: 'sl_topissue',
        key: 'sl_topissue_open',
        name: 'open',
        desc: 'engages with subject lines that include open seat key words',
    },
    {
        type: 'sl_topissue',
        key: 'sl_topissue_othervalidators',
        name: 'othervalidators',
        desc: 'engages with subject lines that include other famous people supporting campaigns (Mark Ruffalo etc.)',
    },
    {
        type: 'sl_topissue',
        key: 'sl_topissue_party',
        name: 'party',
        desc: 'engages with subject lines that include democratic party key words',
    },
    {
        type: 'sl_topissue',
        key: 'sl_topissue_palestine',
        name: 'palestine',
        desc: 'engages with subject lines that include palestine key words',
    },
    {
        type: 'sl_topissue',
        key: 'sl_topissue_pets',
        name: 'pets',
        desc: 'engages with subject lines that include pets key words',
    },
    {
        type: 'sl_topissue',
        key: 'sl_topissue_petition',
        name: 'petition',
        desc: 'engages with subject lines that include petition key words',
    },
    {
        type: 'sl_topissue',
        key: 'sl_topissue_pov_child',
        name: 'pov_child',
        desc: 'engages with subject lines that include child poverty key words',
    },
    {
        type: 'sl_topissue',
        key: 'sl_topissue_pp',
        name: 'pp',
        desc: 'engages with subject lines that include pro choice key words',
    },
    {
        type: 'sl_topissue',
        key: 'sl_topissue_primary',
        name: 'primary',
        desc: 'engages with subject lines that include primary races key words',
    },
    {
        type: 'sl_topissue',
        key: 'sl_topissue_psolver',
        name: 'psolver',
        desc: 'engages with subject lines that include problem solvers candidates (moderates) key words',
    },
    {
        type: 'sl_topissue',
        key: 'sl_topissue_pvi',
        name: 'pvi',
        desc: 'engages with subject lines that include red seats key words',
    },
    {
        type: 'sl_topissue',
        key: 'sl_topissue_recurring',
        name: 'recurring',
        desc: 'engages with subject lines asking for recurring donations',
    },
    {
        type: 'sl_topissue',
        key: 'sl_topissue_redistrict',
        name: 'redistrict',
        desc: 'engages with subject lines that include redistricting key words',
    },
    {
        type: 'sl_topissue',
        key: 'sl_topissue_religion',
        name: 'religion',
        desc: 'engages with subject lines that include religious key words',
    },
    {
        type: 'sl_topissue',
        key: 'sl_topissue_seditionist',
        name: 'seditionist',
        desc: 'engages with subject lines that include January 6th key words',
    },
    {
        type: 'sl_topissue',
        key: 'sl_topissue_senate',
        name: 'senate',
        desc: 'engages with subject lines that include senate races key words',
    },
    {
        type: 'sl_topissue',
        key: 'sl_topissue_statewide',
        name: 'statewide',
        desc: 'engages with subject lines that include statewide races key words',
    },
    {
        type: 'sl_topissue',
        key: 'sl_topissue_strong_dsa',
        name: 'strong_dsa',
        desc: 'engages with subject lines that include dsa key words',
    },
    {
        type: 'sl_topissue',
        key: 'sl_topissue_survey',
        name: 'survey',
        desc: 'engages with subject lines that include survey key words',
    },
    {
        type: 'sl_topissue',
        key: 'sl_topissue_tossup',
        name: 'tossup',
        desc: 'engages with subject lines that include frontline and red to blue race key words',
    },
    {
        type: 'sl_topissue',
        key: 'sl_topissue_under40',
        name: 'under40',
        desc: 'engages with subject lines that include candidate under 40 key words',
    },
    {
        type: 'sl_topissue',
        key: 'sl_topissue_unions',
        name: 'unions',
        desc: 'engages with subject lines that include union key words',
    },
    {
        type: 'sl_topissue',
        key: 'sl_topissue_villain',
        name: 'villain',
        desc: 'engages with subject lines that include villain key words',
    },
    {
        type: 'sl_topissue',
        key: 'sl_topissue_vote_vets',
        name: 'vote_vets',
        desc: 'engages with subject lines that include vet key words',
    },
];

export const TxtTopIssues = [
    {
        type: 'txt_topissue',
        key: 'txt_topissue_afam',
        name: 'afam',
        desc: 'donated to p2p text with african american rights/candidates key words',
    },
    {
        type: 'txt_topissue',
        key: 'txt_topissue_family',
        name: 'family',
        desc: 'donated to p2p text with family member key words',
    },
    {
        type: 'txt_topissue',
        key: 'txt_topissue_aipac',
        name: 'aipac',
        desc: 'donated to p2p text with AIPAC key words',
    },
    {
        type: 'txt_topissue',
        key: 'txt_topissue_animal',
        name: 'animal',
        desc: 'donated to p2p text with animal welfare key words',
    },
    {
        type: 'txt_topissue',
        key: 'txt_topissue_arts',
        name: 'arts',
        desc: 'donated to p2p text with arts key words',
    },
    {
        type: 'txt_topissue',
        key: 'txt_topissue_asian',
        name: 'asian',
        desc: 'donated to p2p text with asian american rights/candidates key words',
    },
    {
        type: 'txt_topissue',
        key: 'txt_topissue_athletics',
        name: 'athletics',
        desc: 'donated to p2p text with athletics key words',
    },
    {
        type: 'txt_topissue',
        key: 'txt_topissue_bernie',
        name: 'bernie',
        desc: 'donated to p2p text with progressive key words',
    },
    {
        type: 'txt_topissue',
        key: 'txt_topissue_bday',
        name: 'bday',
        desc: 'donated to p2p text with birthday key words',
    },
    {
        type: 'txt_topissue',
        key: 'txt_topissue_blm',
        name: 'blm',
        desc: 'donated to p2p text with black lives matter key words',
    },
    {
        type: 'txt_topissue',
        key: 'txt_topissue_bluedog',
        name: 'bluedog',
        desc: 'donated to p2p text with blue dog (moderate cands) key words',
    },
    {
        type: 'txt_topissue',
        key: 'txt_topissue_celebrity',
        name: 'celebrity',
        desc: 'donated to p2p text with celebrity key words',
    },
    {
        type: 'txt_topissue',
        key: 'txt_topissue_chall',
        name: 'chall',
        desc: 'donated to p2p text with challenger candidates key words',
    },
    {
        type: 'txt_topissue',
        key: 'txt_topissue_citywide',
        name: 'citywide',
        desc: 'donated to p2p text with citywide candidates key words',
    },
    {
        type: 'txt_topissue',
        key: 'txt_topissue_courts',
        name: 'courts',
        desc: 'donated to p2p text with courts/scotus key words',
    },
    {
        type: 'txt_topissue',
        key: 'txt_topissue_crimjust',
        name: 'crimjust',
        desc: 'donated to p2p text with criminal justice key words',
    },
    {
        type: 'txt_topissue',
        key: 'txt_topissue_data_centers',
        name: 'data_centers',
        desc: 'donated to p2p text with data centers key words',
    },
    {
        type: 'txt_topissue',
        key: 'txt_topissue_deadline',
        name: 'deadline',
        desc: 'donated to p2p text with deadline key words',
    },
    {
        type: 'txt_topissue',
        key: 'txt_topissue_democracy',
        name: 'democracy',
        desc: 'donated to text with keywords regarding democracy, authoritarianism, and voting',
    },
    {
        type: 'txt_topissue',
        key: 'txt_topissue_disasterrelief',
        name: 'disasterrelief',
        desc: 'donated to text about natural disaster events and disaster relief efforts',
    },
    {
        type: 'txt_topissue',
        key: 'txt_topissue_doge',
        name: 'doge',
        desc: 'donated to texts relating to elon musk and doge',
    },
    { type: 'txt_topissue', key: 'txt_topissue_dsa', name: 'dsa', desc: 'donated to p2p text with dsa key words' },
    {
        type: 'txt_topissue',
        key: 'txt_topissue_education',
        name: 'education',
        desc: 'donated to p2p text with education policy key words',
    },
    {
        type: 'txt_topissue',
        key: 'txt_topissue_enviro',
        name: 'enviro',
        desc: 'donated to p2p text with environmental key words',
    },
    {
        type: 'txt_topissue',
        key: 'txt_topissue_economy',
        name: 'economy',
        desc: 'donated to p2p text with economy key words',
    },
    {
        type: 'txt_topissue',
        key: 'txt_topissue_foreignp',
        name: 'foreignp',
        desc: 'donated to p2p text with foreign policy key words',
    },
    {
        type: 'txt_topissue',
        key: 'txt_topissue_ftn',
        name: 'ftn',
        desc: 'donated to p2p text with first then now key words',
    },
    {
        type: 'txt_topissue',
        key: 'txt_topissue_gbn',
        name: 'gbn',
        desc: 'donated to p2p text with good news bad news key words',
    },
    {
        type: 'txt_topissue',
        key: 'txt_topissue_gender',
        name: 'gender',
        desc: 'donated to p2p text with womens rights/candidates key words',
    },
    {
        type: 'txt_topissue',
        key: 'txt_topissue_gotv',
        name: 'gotv',
        desc: 'donated to p2p text with getting out the vote key words',
    },
    {
        type: 'txt_topissue',
        key: 'txt_topissue_govshutdown',
        name: 'govshutdown',
        desc: 'donated to p2p text with government shutdown key words',
    },
    {
        type: 'txt_topissue',
        key: 'txt_topissue_green',
        name: 'green',
        desc: 'donated to p2p text with green new deal key words',
    },
    {
        type: 'txt_topissue',
        key: 'txt_topissue_guns',
        name: 'guns',
        desc: 'donated to p2p text with gun control key words',
    },
    {
        type: 'txt_topissue',
        key: 'txt_topissue_house',
        name: 'house',
        desc: 'donated to p2p text with house races key words',
    },
    {
        type: 'txt_topissue',
        key: 'txt_topissue_housing',
        name: 'housing',
        desc: 'donated to p2p text with affordable housing key words',
    },
    { type: 'txt_topissue', key: 'txt_topissue_hrc', name: 'hrc', desc: 'donated to p2p text with lgbtq key words' },
    {
        type: 'txt_topissue',
        key: 'txt_topissue_ideology',
        name: 'ideology',
        desc: 'donated to p2p text with progressive key words',
    },
    {
        type: 'txt_topissue',
        key: 'txt_topissue_immigration',
        name: 'immigration',
        desc: 'donated to p2p text with immigration key words',
    },
    {
        type: 'txt_topissue',
        key: 'txt_topissue_incumbent',
        name: 'incumbent',
        desc: 'donated to p2p text with incumbent candidates key words',
    },
    {
        type: 'txt_topissue',
        key: 'txt_topissue_issue',
        name: 'issue',
        desc: 'donated to p2p text with PACs/nonprofits key words',
    },
    {
        type: 'txt_topissue',
        key: 'txt_topissue_jewish',
        name: 'jewish',
        desc: 'donated to p2p text with jewish rights/candidates key words',
    },
    {
        type: 'txt_topissue',
        key: 'txt_topissue_jstreet',
        name: 'jstreet',
        desc: 'donated to p2p text with jstreet key words',
    },
    {
        type: 'txt_topissue',
        key: 'txt_topissue_latino',
        name: 'latino',
        desc: 'donated to p2p text with latino rights/candidates key words',
    },
    {
        type: 'txt_topissue',
        key: 'txt_topissue_launch',
        name: 'launch',
        desc: 'donated to p2p text with launch key words',
    },
    {
        type: 'txt_topissue',
        key: 'txt_topissue_lgbt',
        name: 'lgbt',
        desc: 'donated to p2p text with lgbtq rights/candidates key words',
    },
    {
        type: 'txt_topissue',
        key: 'txt_topissue_lowdollarask',
        name: 'lowdollarask',
        desc: 'donated to p2p text with low dollar ask key words',
    },
    {
        type: 'txt_topissue',
        key: 'txt_topissue_lpac',
        name: 'lpac',
        desc: 'donated to p2p text with lesbian rights/candidates key words',
    },
    {
        type: 'txt_topissue',
        key: 'txt_topissue_lweed',
        name: 'lweed',
        desc: 'donated to p2p text with legalizing weed key words',
    },
    {
        type: 'txt_topissue',
        key: 'txt_topissue_match',
        name: 'match',
        desc: 'responsive to texts with donation matching tactics',
    },
    {
        type: 'txt_topissue',
        key: 'txt_topissue_medical',
        name: 'medical',
        desc: 'donated to p2p text with medical research key words',
    },
    {
        type: 'txt_topissue',
        key: 'txt_topissue_moderate',
        name: 'moderate',
        desc: 'donated to p2p text with moderate key words',
    },
    {
        type: 'txt_topissue',
        key: 'txt_topissue_muslim',
        name: 'muslim',
        desc: 'donated to p2p text with muslim rights/candidates key words',
    },
    {
        type: 'txt_topissue',
        key: 'txt_topissue_newpol',
        name: 'newpol',
        desc: 'donated to p2p text with new politics (moderate cands) key words',
    },
    {
        type: 'txt_topissue',
        key: 'txt_topissue_newsval',
        name: 'newsval',
        desc: 'donated to p2p text with news validators key words',
    },
    {
        type: 'txt_topissue',
        key: 'txt_topissue_npeoygiving',
        name: 'npeoygiving',
        desc: 'donated to p2p text with giving to non profits around the end of year push key words',
    },
    {
        type: 'txt_topissue',
        key: 'txt_topissue_obama',
        name: 'obama',
        desc: 'donated to p2p text with pres. obama key words',
    },
    {
        type: 'txt_topissue',
        key: 'txt_topissue_open',
        name: 'open',
        desc: 'donated to p2p text with open seats key words',
    },
    {
        type: 'txt_topissue',
        key: 'txt_topissue_otherval',
        name: 'otherval',
        desc: 'donated to p2p text with other high profile validators (not news) key words',
    },
    {
        type: 'txt_topissue',
        key: 'txt_topissue_palestine',
        name: 'palestine',
        desc: 'donated to p2p text with palestine key words',
    },
    {
        type: 'txt_topissue',
        key: 'txt_topissue_party',
        name: 'party',
        desc: 'donated to p2p text with democratic party key words',
    },
    { type: 'txt_topissue', key: 'txt_topissue_pets', name: 'pets', desc: 'donated to p2p text with pets key words' },
    {
        type: 'txt_topissue',
        key: 'txt_topissue_petition',
        name: 'petition',
        desc: 'donated to p2p text with petition key words',
    },
    {
        type: 'txt_topissue',
        key: 'txt_topissue_pov_child',
        name: 'pov_child',
        desc: 'donated to p2p text with child poverty key words',
    },
    { type: 'txt_topissue', key: 'txt_topissue_pp', name: 'pp', desc: 'donated to p2p text with pro choice key words' },
    {
        type: 'txt_topissue',
        key: 'txt_topissue_primary',
        name: 'primary',
        desc: 'donated to p2p text with primary elections key words',
    },
    {
        type: 'txt_topissue',
        key: 'txt_topissue_psolver',
        name: 'psolver',
        desc: 'donated to p2p text with problem solver (bipartisan cands) key words',
    },
    {
        type: 'txt_topissue',
        key: 'txt_topissue_pvi',
        name: 'pvi',
        desc: 'donated to p2p text with flipping red seats key words',
    },
    {
        type: 'txt_topissue',
        key: 'txt_topissue_recurring',
        name: 'recurring',
        desc: 'donated to p2p text with recurring asks key words',
    },
    {
        type: 'txt_topissue',
        key: 'txt_topissue_redistrict',
        name: 'redistrict',
        desc: 'donated to p2p text with redistricting key words',
    },
    {
        type: 'txt_topissue',
        key: 'txt_topissue_religion',
        name: 'religion',
        desc: 'donated to p2p text with religious key words',
    },
    {
        type: 'txt_topissue',
        key: 'txt_topissue_seditionist',
        name: 'seditionist',
        desc: 'donated to p2p text with anti-seditionist key words',
    },
    {
        type: 'txt_topissue',
        key: 'txt_topissue_senate',
        name: 'senate',
        desc: 'donated to p2p text with senate races key words',
    },
    {
        type: 'txt_topissue',
        key: 'txt_topissue_statewide',
        name: 'statewide',
        desc: 'donated to p2p text with statewide candidates key words',
    },
    {
        type: 'txt_topissue',
        key: 'txt_topissue_strongdsa',
        name: 'strongdsa',
        desc: 'donated to p2p text with dsa key words',
    },
    {
        type: 'txt_topissue',
        key: 'txt_topissue_survey',
        name: 'survey',
        desc: 'donated to p2p text with survey key words',
    },
    {
        type: 'txt_topissue',
        key: 'txt_topissue_tossup',
        name: 'tossup',
        desc: 'donated to p2p text with frontline and red to blue race key words',
    },
    {
        type: 'txt_topissue',
        key: 'txt_topissue_under40',
        name: 'under40',
        desc: 'donated to p2p text with candidates under 40 key words',
    },
    {
        type: 'txt_topissue',
        key: 'txt_topissue_union',
        name: 'union',
        desc: 'donated to p2p text with union key words',
    },
    {
        type: 'txt_topissue',
        key: 'txt_topissue_villain',
        name: 'villain',
        desc: 'donated to p2p text with villain key words',
    },
    {
        type: 'txt_topissue',
        key: 'txt_topissue_votevets',
        name: 'votevets',
        desc: 'donated to p2p text with vet key words',
    },
];

export const Genders = [
    { name: 'male', key: 'male' },
    { name: 'gender unsure', key: 'gender unsure' },
    { name: 'female', key: 'female' },
];

export const RuralStatus = [
    { name: 'rural', key: 'rural' },
    { name: 'urban', key: 'urban' },
    { name: 'suburban', key: 'suburban' },
];

export const integerOperators = ['=', '<', '<=', '>', '>=', '!='];
const onlyEqualsOperator = ['='];
const equalityOperators = ['=', '!='];
export const onlyContainsOperator = ['CONTAINS'];
const containsOperators = [...onlyContainsOperator, 'DOES NOT CONTAIN'];
export const stringOperators = [...equalityOperators, ...containsOperators];
export const inOperator = ['IN', 'NOT IN'];
export const onlyInOperator = ['IN'];
export const dateOperators = ['SINCE', 'BETWEEN'];
export const nullOperators = ['IS NULL', 'IS NOT NULL'];

export const Fields = [
    { name: '', operators: onlyEqualsOperator, basket: null, component: TextRule },
    {
        name: 'abx',
        operators: onlyEqualsOperator.concat(nullOperators),
        basket: null,
        component: BoolRule,
        desc: 'donor has an act blue express account',
    },
    {
        name: 'active_email_percentile',
        operators: integerOperators.concat(nullOperators),
        basket: null,
        component: FloatRule,
        desc: "donor's percentile [0.0 to 1.0] for email activity among all donors",
    },
    {
        name: 'active_email_score',
        operators: integerOperators.concat(nullOperators),
        basket: null,
        component: FloatRule,
        desc: "Measures how engaged a person is with email outreach, on a scale of 0-10. It sums up factors such as whether they've donated to email before, how recently they clicked or opened an email, and their click and open rate. A score of 0 means we found no email history for this person. Active_email_rank and active_email_percentile can be used to find who is more or less active relative to others with known email history.",
    },
    {
        name: 'active_mail_percentile',
        operators: integerOperators.concat(nullOperators),
        basket: null,
        component: FloatRule,
        desc: "donor's percentile [0.0 to 1.0] for mail activity among all donors",
    },
    {
        name: 'active_mail_score',
        operators: integerOperators.concat(nullOperators),
        basket: null,
        component: FloatRule,
        desc: 'score based on mail exhaust data - scale 0 -10',
    },
    {
        name: 'active_mobile_percentile',
        operators: integerOperators.concat(nullOperators),
        basket: null,
        component: FloatRule,
        desc: "donor's percentile [0.0 to 1.0] for mobile activity among all donors",
    },
    {
        name: 'active_mobile_score',
        operators: integerOperators.concat(nullOperators),
        basket: null,
        component: FloatRule,
        desc: "Measures how engaged a person is with mobile/text outreach, on a scale of 0-10. It sums up factors such as whether they've donated through text before, how recently they were texted, and whether they have opted in or out of texts. A score of 0 means we found no mobile history for this person. Active_mobile_rank and active_mobile_percentile can be used to find who is more or less active relative to others with known mobile history.",
    },
    {
        name: 'active_messenger_percentile',
        operators: integerOperators.concat(nullOperators),
        basket: null,
        component: FloatRule,
        desc: "donor's percentile [0.0 to 1.0] for messenger activity among all donors",
    },
    {
        name: 'active_messenger_score',
        operators: integerOperators.concat(nullOperators),
        basket: null,
        component: FloatRule,
        desc: "Measures how engaged a person is with Meta/Facebook messaging outreach, on a scale of 0-10. It sums up factors such as how recently they donated through Meta/Facebook messenger and whether they've given on a mobile device. A score of 0 means we've found no Meta/Facebook messenger donation history. Active_messenger_rank and active_messenger_percentile can be used to find who is more or less active relative to others with known messenger history.",
    },
    {
        name: 'active_nonprofit_mobile_percentile',
        operators: integerOperators.concat(nullOperators),
        basket: null,
        component: FloatRule,
        desc: "donor's percentile [0.0 to 1.0] for mobile activity among all donors to nonprofits",
    },
    {
        name: 'active_nonprofit_mobile_score',
        operators: integerOperators.concat(nullOperators),
        basket: null,
        component: FloatRule,
        desc: '0-10 score of how active a mobile number is among donors to nonprofits',
    },
    {
        name: 'address',
        operators: equalityOperators.concat(nullOperators),
        basket: null,
        component: TextRule,
        desc: 'all cap street address (806 7TH ST NW)',
    },
    {
        name: 'ask',
        operators: integerOperators,
        basket: null,
        component: IntRule,
        desc: 'recommended amount of money a given client should ask a given donor',
    },
    {
        name: 'attorney_general_sum',
        operators: integerOperators,
        basket: null,
        component: IntRule,
        desc: 'number of donations to attorney general races',
    },
    {
        name: 'avg_click_rate',
        operators: integerOperators.concat(nullOperators),
        basket: null,
        component: FloatRule,
        desc: 'number of emails / number of clicks',
    },
    {
        name: 'avg_give_per_cycle',
        operators: integerOperators.concat(nullOperators),
        basket: null,
        component: FloatRule,
        desc: 'average amount of money a person gives over the course of 2 years',
    },
    {
        name: 'avg_open_rate',
        operators: integerOperators.concat(nullOperators),
        basket: null,
        component: FloatRule,
        desc: 'number of emails / number of opens',
    },
    {
        name: 'avg_unsub_rate',
        operators: integerOperators.concat(nullOperators),
        basket: null,
        component: FloatRule,
        desc: 'percentage of emails a person unsubscribes to',
    },
    {
        name: 'ballot_initiative_sum',
        operators: integerOperators.concat(nullOperators),
        basket: null,
        component: IntRule,
        desc: 'number of ballot initiatives an donor has financially supported',
    },
    {
        name: 'bounced',
        operators: onlyEqualsOperator.concat(nullOperators),
        basket: null,
        component: BoolRule,
        desc: 'email bounced',
    },
    {
        name: 'calltime_conversions',
        operators: integerOperators.concat(nullOperators),
        basket: null,
        component: IntRule,
        desc: 'number of call time donations',
    },
    {
        name: 'cc_tw_total_clicks',
        operators: integerOperators.concat(nullOperators),
        basket: null,
        component: FloatRule,
        desc: 'time weighted clicks from click collective data',
    },
    {
        name: 'cc_tw_total_unsubs',
        operators: integerOperators.concat(nullOperators),
        basket: null,
        component: FloatRule,
        desc: 'time weighted unsubscribes from click collective data',
    },
    {
        name: 'city',
        operators: stringOperators.concat(nullOperators),
        basket: null,
        component: TextRule,
        desc: 'all caps city (MASSENA)',
    },
    {
        name: 'citywide_cand_string',
        operators: containsOperators.concat(nullOperators),
        basket: null,
        component: TextRule,
        desc: 'uppercase citywide donations',
    },
    {
        name: 'citywide_contribution_avg',
        operators: integerOperators.concat(nullOperators),
        basket: null,
        component: FloatRule,
        desc: 'average City-level contribution size',
    },
    {
        name: 'citywide_contribution_count',
        operators: integerOperators.concat(nullOperators),
        basket: null,
        component: IntRule,
        desc: 'number of city-level contributions',
    },
    {
        name: 'citywide_multistate_sum',
        operators: integerOperators.concat(nullOperators),
        basket: null,
        component: FloatRule,
        desc: 'number of different states a donor has given to a city-level candidate in',
    },
    {
        name: 'contrib_ideology',
        operators: integerOperators.concat(nullOperators),
        basket: null,
        component: FloatRule,
        desc: "An ideology score that ranks how progressive a person's donation history is, on a scale from 0-100. It is calculated from the average of ideology scores of candidates and causes they donated to. A score above 60 is safely considered Democratic.",
    },
    {
        name: 'contribution_avg',
        operators: integerOperators.concat(nullOperators),
        basket: null,
        component: FloatRule,
        desc: 'average contribution amount',
    },
    {
        name: 'contribution_max',
        operators: integerOperators.concat(nullOperators),
        basket: null,
        component: FloatRule,
        desc: 'highest contribution amount',
    },
    {
        name: 'contribution_min',
        operators: integerOperators.concat(nullOperators),
        basket: null,
        component: FloatRule,
        desc: 'lowest contribution amount',
    },
    {
        name: 'contributions_afam',
        operators: integerOperators.concat(nullOperators),
        basket: null,
        component: IntRule,
        desc: 'number of donations to afam candidates',
    },
    {
        name: 'contributions_asianam',
        operators: integerOperators.concat(nullOperators),
        basket: null,
        component: IntRule,
        desc: 'number of donations to asian-american candidates',
    },
    {
        name: 'contributions_bernie',
        operators: integerOperators.concat(nullOperators),
        basket: null,
        component: IntRule,
        desc: 'number of donations to progressive candidates',
    },
    {
        name: 'contributions_challenger',
        operators: integerOperators.concat(nullOperators),
        basket: null,
        component: IntRule,
        desc: 'number of donations to challengers',
    },
    {
        name: 'contributions_gender',
        operators: integerOperators.concat(nullOperators),
        basket: null,
        component: IntRule,
        desc: 'number of donations to women candidates',
    },
    {
        name: 'contributions_incumbent',
        operators: integerOperators.concat(nullOperators),
        basket: null,
        component: IntRule,
        desc: 'number of donations to incumbents',
    },
    {
        name: 'contributions_jewish',
        operators: integerOperators.concat(nullOperators),
        basket: null,
        component: IntRule,
        desc: 'number of donations to jewish candidates',
    },
    {
        name: 'contributions_latino',
        operators: integerOperators.concat(nullOperators),
        basket: null,
        component: IntRule,
        desc: 'number of donations to latino candidates',
    },
    {
        name: 'contributions_lgbtq',
        operators: integerOperators.concat(nullOperators),
        basket: null,
        component: IntRule,
        desc: 'number of donations to LGBTQ candidates',
    },
    {
        name: 'contributions_muslim',
        operators: integerOperators.concat(nullOperators),
        basket: null,
        component: IntRule,
        desc: 'number of donations to muslim candidates',
    },
    {
        name: 'contributions_open',
        operators: integerOperators.concat(nullOperators),
        basket: null,
        component: IntRule,
        desc: 'number of donations to people running in open seats',
    },
    {
        name: 'contributions_primary',
        operators: integerOperators.concat(nullOperators),
        basket: null,
        component: IntRule,
        desc: 'number of donations to people running in primaries',
    },
    {
        name: 'contributions_under40',
        operators: integerOperators.concat(nullOperators),
        basket: null,
        component: IntRule,
        desc: 'number of donations to candidates under 40 years old',
    },
    {
        name: 'contributor_age',
        operators: integerOperators.concat(nullOperators),
        basket: null,
        component: IntRule,
        desc: 'donor age',
    },
    {
        name: 'contributor_dob',
        operators: dateOperators,
        basket: null,
        component: DateRule,
        desc: 'donor date of birth',
    },
    {
        name: 'contributor_gender',
        operators: equalityOperators,
        basket: null,
        component: GenderRule,
        desc: 'gender of a donor',
    },
    {
        name: 'contributor_rural_urban_status',
        operators: equalityOperators.concat(nullOperators),
        basket: null,
        component: RuralRule,
        desc: 'categorical variable, does this person live in the suburbs, the city, or the country',
    },
    {
        name: 'conversion_rate_email',
        operators: integerOperators.concat(nullOperators),
        basket: null,
        component: FloatRule,
        desc: 'emails sent / emails donated to',
    },
    {
        name: 'conversion_rate_p2p',
        operators: integerOperators.concat(nullOperators),
        basket: null,
        component: FloatRule,
        desc: 'number of texts / number of gifts',
    },
    {
        name: 'Count of distinct donations in (loop - special basket)',
        operators: integerOperators,
        basket: [],
        component: DistinctDonationsBasketRule,
        desc: '',
    },
    {
        name: 'Count of donations to (custom basket)',
        operators: integerOperators,
        basket: [],
        component: IntRule,
        desc: '',
    },
    {
        name: 'Count of donations to (loop - special basket)',
        operators: integerOperators,
        basket: [],
        component: DonationBasketRule,
        desc: '',
    },
    {
        name: 'Count of donations to (standard basket)',
        operators: integerOperators,
        basket: StandardBaskets,
        component: IntRule,
        desc: '',
    },
    {
        name: 'countyname',
        operators: stringOperators.concat(nullOperators),
        basket: null,
        component: TextRule,
        desc: "county name including 'county' suffix ('los ageles county')",
    },
    {
        name: 'date1',
        operators: dateOperators,
        basket: null,
        component: DateRule,
        desc: 'most recent date of donation',
    },
    {
        name: 'days_at_current_address',
        operators: integerOperators.concat(nullOperators),
        basket: null,
        component: IntRule,
        desc: 'number of days someone has lived at their current address',
    },
    {
        name: 'days_since_given_by_email',
        operators: integerOperators.concat(nullOperators),
        basket: null,
        component: IntRule,
        desc: 'number of days since last email donation',
    },
    {
        name: 'days_since_given_by_tagged_text',
        operators: integerOperators.concat(nullOperators),
        basket: null,
        component: IntRule,
        desc: 'number of days since a donation was made in response to a known text with a refcode',
    },
    {
        name: 'days_since_v_address',
        operators: integerOperators.concat(nullOperators),
        basket: null,
        component: IntRule,
        desc: 'number of days since an address has been verified',
    },
    {
        name: 'democrat_sum',
        operators: integerOperators.concat(nullOperators),
        basket: null,
        component: IntRule,
        desc: 'number of donations to dems',
    },
    {
        name: 'Demographic (or - special basket)',
        operators: inOperator,
        basket: [],
        component: DemographicBasketRule,
        desc: '',
    },
    {
        name: 'demographic',
        operators: stringOperators.concat(nullOperators),
        basket: null,
        component: TextRule,
        desc: 'demographic based on name analysis (likely white)',
    },
    {
        name: 'digital_ad_conversions',
        operators: integerOperators.concat(nullOperators),
        basket: null,
        component: IntRule,
        desc: 'number of donations made through digital ads',
    },
    {
        name: 'donor_momentum',
        operators: integerOperators.concat(nullOperators),
        basket: null,
        component: FloatRule,
        desc: 'The ratio of the number donations this cycle to the last cycle. A value close to 1 means they donated at the same rate both cycles. Greater than 1 means they donated more this cycle than last cycle; less than 1 means they donated more last cycle than this cycle.',
    },
    {
        name: 'donor_region',
        operators: stringOperators.concat(nullOperators),
        basket: null,
        component: TextRule,
        desc: 'region of the county a donor lives in based on the US census',
    },
    {
        name: 'early_donor',
        operators: onlyEqualsOperator.concat(nullOperators),
        basket: null,
        component: BoolRule,
        desc: 'Made a donation to a campaign launch',
    },
    {
        name: 'email_conversions',
        operators: integerOperators.concat(nullOperators),
        basket: null,
        component: IntRule,
        desc: 'number of donations made over email',
    },
    {
        name: 'email_donation_average',
        operators: integerOperators.concat(nullOperators),
        basket: null,
        component: FloatRule,
        desc: 'donors average email gift',
    },
    {
        name: 'email_origin',
        operators: containsOperators.concat(nullOperators),
        basket: null,
        component: TextRule,
        desc: 'how GA received the email',
    },
    {
        name: 'email_per_day_index',
        operators: integerOperators.concat(nullOperators),
        basket: null,
        component: FloatRule,
        desc: 'estimated number of emails a donor recieves in one day',
    },
    {
        name: 'email1',
        operators: stringOperators.concat(nullOperators),
        basket: null,
        component: TextRule,
        desc: 'best email for a donor',
    },
    {
        name: 'emailablemxrecord',
        operators: stringOperators.concat(nullOperators),
        basket: null,
        component: TextRule,
        desc: 'domain from emailable',
    },
    {
        name: 'emailablescore',
        operators: integerOperators.concat(nullOperators),
        basket: null,
        component: FloatRule,
        desc: 'emailable score (80+ is devliverable, 1-79 is risky, 0 is undeliverable)',
    },
    {
        name: 'employer',
        operators: stringOperators.concat(nullOperators),
        basket: null,
        component: TextRule,
        desc: 'employer name (grassroots analytics)',
    },
    {
        name: 'federalcand_sum',
        operators: integerOperators.concat(nullOperators),
        basket: null,
        component: IntRule,
        desc: 'number of federal candidate donations',
    },
    {
        name: 'first_name',
        operators: stringOperators.concat(nullOperators),
        basket: null,
        component: TextRule,
        desc: 'proper case first name (Danny)',
    },
    {
        name: 'firsttime_candidate_sum',
        operators: integerOperators.concat(nullOperators),
        basket: null,
        component: IntRule,
        desc: 'number of 1st time candidates someone has given to',
    },
    {
        name: 'gave_on_mobiledevice',
        operators: onlyEqualsOperator.concat(nullOperators),
        basket: null,
        component: BoolRule,
        desc: 'made a donation from a smartphone',
    },
    {
        name: 'gov_donation_sum',
        operators: integerOperators.concat(nullOperators),
        basket: null,
        component: IntRule,
        desc: 'number of donations to gubernatorial races',
    },
    { name: 'home', operators: nullOperators, basket: null, component: TextRule, desc: 'home phone number' },
    {
        name: 'house_cand_string',
        operators: containsOperators.concat(nullOperators),
        basket: null,
        component: TextRule,
        desc: 'lowercase House donations',
    },
    {
        name: 'house_contribution_avg',
        operators: integerOperators.concat(nullOperators),
        basket: null,
        component: FloatRule,
        desc: 'average House contribution size',
    },
    {
        name: 'house_contribution_max',
        operators: integerOperators.concat(nullOperators),
        basket: null,
        component: FloatRule,
        desc: 'highest contribution to a House race',
    },
    {
        name: 'house_multistate_sum',
        operators: integerOperators.concat(nullOperators),
        basket: null,
        component: IntRule,
        desc: 'number of different states a donor has given to a house candidate in',
    },
    {
        name: 'house_sum',
        operators: integerOperators.concat(nullOperators),
        basket: null,
        component: IntRule,
        desc: 'number of House donations (unique by candidate)',
    },
    {
        name: 'investment_cand_string',
        operators: containsOperators.concat(nullOperators),
        basket: null,
        component: TextRule,
        desc: 'string of all investments a person has made',
    },
    {
        name: 'investment_sum',
        operators: integerOperators.concat(nullOperators),
        basket: null,
        component: IntRule,
        desc: 'number of investments a person has made',
    },
    {
        name: 'issue_cand_string',
        operators: containsOperators.concat(nullOperators),
        basket: null,
        component: TextRule,
        desc: 'lowercase for federal pacs and uppercase for state pacs',
    },
    {
        name: 'issue_contribution_avg',
        operators: integerOperators.concat(nullOperators),
        basket: null,
        component: FloatRule,
        desc: 'average PAC/Nonprofit contribution size',
    },
    {
        name: 'issue_sum',
        operators: integerOperators.concat(nullOperators),
        basket: null,
        component: IntRule,
        desc: 'number of PAC + nonprofit donations (unique by candidate)',
    },
    {
        name: 'judicious_clicker',
        operators: onlyEqualsOperator.concat(nullOperators),
        basket: null,
        component: BoolRule,
        desc: 'Someone who unsubscribes more than they click',
    },
    {
        name: 'judicial_count',
        operators: integerOperators.concat(nullOperators),
        basket: null,
        component: IntRule,
        desc: 'number of judicial donations',
    },
    {
        name: 'lastcycle_sum',
        operators: integerOperators.concat(nullOperators),
        basket: null,
        component: IntRule,
        desc: 'amount given in the last full cycle',
    },
    {
        name: 'lastcycle_count',
        operators: integerOperators.concat(nullOperators),
        basket: null,
        component: IntRule,
        desc: 'number of donations in the last full cycle',
    },
    {
        name: 'last_dem_amount',
        operators: integerOperators.concat(nullOperators),
        basket: null,
        component: IntRule,
        desc: 'amount given to last dem',
    },
    {
        name: 'last_dem_date',
        operators: dateOperators,
        basket: null,
        component: DateRule,
        desc: 'date of last dem donation',
    },
    {
        name: 'last_gop_amount',
        operators: integerOperators.concat(nullOperators),
        basket: null,
        component: IntRule,
        desc: 'amount of last gop donation',
    },
    {
        name: 'last_gop_date',
        operators: dateOperators,
        basket: null,
        component: DateRule,
        desc: 'date of last gop donation',
    },
    {
        name: 'last_name',
        operators: stringOperators.concat(nullOperators),
        basket: null,
        component: TextRule,
        desc: 'last name (e.g. Hogenkamp)',
    },
    {
        name: 'likely_alma_mater',
        operators: stringOperators.concat(nullOperators),
        basket: null,
        component: TextRule,
        desc: 'guessing someones college based on their donations to the institution',
    },
    {
        name: 'linkedin_url',
        operators: containsOperators.concat(nullOperators),
        basket: null,
        component: TextRule,
        desc: 'donor linkedin profile',
    },
    {
        name: 'mail_conversions',
        operators: integerOperators.concat(nullOperators),
        basket: null,
        component: IntRule,
        desc: 'donations made through the mail',
    },
    {
        name: 'messenger_conversions',
        operators: integerOperators.concat(nullOperators),
        basket: null,
        component: IntRule,
        desc: 'donations made through Facebook messenger',
    },
    {
        name: 'metro',
        operators: stringOperators.concat(nullOperators),
        basket: null,
        component: TextRule,
        desc: 'metropolitan area a donor lives in (New York)',
    },
    {
        name: 'mobile_conversions',
        operators: integerOperators.concat(nullOperators),
        basket: null,
        component: IntRule,
        desc: 'donations made after solicited via text',
    },
    {
        name: 'mobile_opt_in',
        operators: onlyEqualsOperator.concat(nullOperators),
        basket: null,
        component: BoolRule,
        desc: 'opted in to receive texts from one of our clients',
    },
    {
        name: 'mobile_origin',
        operators: containsOperators.concat(nullOperators),
        basket: null,
        component: TextRule,
        desc: 'how GA received the mobile number. This is not compatible with legacy data.',
    },
    {
        name: 'mobile_per_day_index',
        operators: integerOperators.concat(nullOperators),
        basket: null,
        component: FloatRule,
        desc: 'intermediate variable',
    },
    { name: 'mobile', operators: nullOperators, basket: null, component: TextRule, desc: 'mobile phone number' },
    {
        name: 'most_old_email_date',
        operators: dateOperators,
        basket: null,
        component: DateRule,
        desc: 'first time an email was imported',
    },
    {
        name: 'modeled_ad_conversions',
        operators: integerOperators.concat(nullOperators),
        basket: null,
        component: IntRule,
        desc: 'modeled ads donations based on new and improved formula',
    },
    {
        name: 'modeled_mail_conversions',
        operators: integerOperators.concat(nullOperators),
        basket: null,
        component: IntRule,
        desc: 'mail donations based on new and improved formula',
    },
    {
        name: 'modeled_text_conversions',
        operators: integerOperators.concat(nullOperators),
        basket: null,
        component: IntRule,
        desc: 'modeled text donations based on new and improved formula',
    },
    { name: 'most_recent_click', operators: dateOperators, basket: null, component: DateRule, desc: 'last click date' },
    {
        name: 'most_recent_email_date',
        operators: dateOperators,
        basket: null,
        component: DateRule,
        desc: 'most recent time an email has been imported',
    },
    { name: 'most_recent_open', operators: dateOperators, basket: null, component: DateRule, desc: 'last open date' },
    {
        name: 'net_worth',
        operators: integerOperators.concat(nullOperators),
        basket: null,
        component: FloatRule,
        desc: 'estimated networth 0 - infinity',
    },
    {
        name: 'non_abx_online',
        operators: onlyEqualsOperator.concat(nullOperators),
        basket: null,
        component: BoolRule,
        desc: 'true when a donor has given online somewhere other than ActBlue',
    },
    {
        name: 'nonprofit_cand_string',
        operators: containsOperators.concat(nullOperators),
        basket: null,
        component: TextRule,
        desc: 'uppercase nonprofit donations',
    },
    {
        name: 'nonprofit_contribution_max',
        operators: integerOperators.concat(nullOperators),
        basket: null,
        component: FloatRule,
        desc: 'max donation to a nonprofit',
    },
    {
        name: 'nonprofit_donor_momentum',
        operators: integerOperators.concat(nullOperators),
        basket: null,
        component: FloatRule,
        desc: 'scale 0.5-1.5 scores how active a donor is with nonprofit donations',
    },
    {
        name: 'nonprofit_email_conversions',
        operators: integerOperators.concat(nullOperators),
        basket: null,
        component: IntRule,
        desc: 'number of email donations made to nonprofits',
    },
    {
        name: 'nonprofit_p2p_conversions',
        operators: integerOperators.concat(nullOperators),
        basket: null,
        component: IntRule,
        desc: 'number of p2p donations made to nonprofits',
    },
    {
        name: 'nonprofit_sum',
        operators: integerOperators.concat(nullOperators),
        basket: null,
        component: IntRule,
        desc: 'number of Nonprofit donations (unique by nonprofit)',
    },
    {
        name: 'number_of_donations',
        operators: integerOperators.concat(nullOperators),
        basket: null,
        component: IntRule,
        desc: 'number of donations made',
    },
    {
        name: 'occupation',
        operators: stringOperators.concat(nullOperators),
        basket: null,
        component: TextRule,
        desc: 'all caps occupation (DATA ANALYST)',
    },
    {
        name: 'path2response_tier',
        operators: integerOperators.concat(nullOperators),
        basket: null,
        component: IntRule,
        desc: 'A score from Path2Response. This is mainly used to show someone actually has donated through mail. The scores are meaningless.',
    },
    {
        name: 'p2p_actblue_dislike_count',
        operators: integerOperators.concat(nullOperators),
        basket: null,
        component: IntRule,
        desc: 'number of inbound P2P replies where someone said they dislike ActBlue',
    },
    {
        name: 'p2p_average_opt_out_rate',
        operators: integerOperators.concat(nullOperators),
        basket: null,
        component: FloatRule,
        desc: 'number of texts / number of opt outs',
    },
    {
        name: 'p2p_average_support_rate',
        operators: integerOperators.concat(nullOperators),
        basket: null,
        component: FloatRule,
        desc: 'number of texts / donations or message of support',
    },
    {
        name: 'p2p_cand_conv_string',
        operators: containsOperators.concat(nullOperators),
        basket: null,
        component: TextRule,
        desc: 'who someone has donated to over p2p ',
    },
    {
        name: 'p2p_conversions',
        operators: integerOperators.concat(nullOperators),
        basket: null,
        component: IntRule,
        desc: 'number of p2p donations',
    },
    {
        name: 'p2p_date_of_last_text',
        operators: dateOperators,
        basket: null,
        component: DateRule,
        desc: 'last time someone was texted',
    },
    {
        name: 'p2p_text_count',
        operators: integerOperators.concat(nullOperators),
        basket: null,
        component: IntRule,
        desc: 'number of times someone has been texted',
    },
    {
        name: 'pac_cand_string',
        operators: containsOperators.concat(nullOperators),
        basket: null,
        component: TextRule,
        desc: 'donors pac donations',
    },
    {
        name: 'pac_contribution_avg',
        operators: integerOperators.concat(nullOperators),
        basket: null,
        component: FloatRule,
        desc: 'avg gift to pacs',
    },
    {
        name: 'pac_contribution_count',
        operators: integerOperators.concat(nullOperators),
        basket: null,
        component: IntRule,
        desc: 'number of pac donations',
    },
    {
        name: 'pac_contribution_max',
        operators: integerOperators.concat(nullOperators),
        basket: null,
        component: FloatRule,
        desc: 'max donation to a pac',
    },
    {
        name: 'pac_contribution_sum',
        operators: integerOperators.concat(nullOperators),
        basket: null,
        component: IntRule,
        desc: 'total donation amount to pacs',
    },
    {
        name: 'party_registration',
        operators: containsOperators.concat(nullOperators),
        basket: null,
        component: TextRule,
        desc: 'proper case party registration (Democratic, Republican, Independent, etc.)',
    },
    {
        name: 'party_cand_string',
        operators: containsOperators.concat(nullOperators),
        basket: null,
        component: TextRule,
        desc: 'lowercase Party donations',
    },
    {
        name: 'party_contribution_avg',
        operators: integerOperators.concat(nullOperators),
        basket: null,
        component: FloatRule,
        desc: 'average Party contribution size',
    },
    {
        name: 'party_sum',
        operators: integerOperators.concat(nullOperators),
        basket: null,
        component: IntRule,
        desc: 'number of Party donations (unique by candidate)',
    },
    {
        name: 'political_max',
        operators: integerOperators.concat(nullOperators),
        basket: null,
        component: FloatRule,
        desc: 'highest contribution amount made to any political campaign or organization',
    },
    {
        name: 'possible_spanish_speaker',
        operators: onlyEqualsOperator.concat(nullOperators),
        basket: null,
        component: BoolRule,
        desc: 'likely spanish speaker',
    },
    {
        name: 'potential_mail_donor',
        operators: integerOperators.concat(nullOperators),
        basket: null,
        component: FloatRule,
        desc: 'modeled likelihood that a donor would give through mail',
    },
    {
        name: 'presidential_cand_string',
        operators: containsOperators.concat(nullOperators),
        basket: null,
        component: TextRule,
        desc: 'lowercase presidential donations',
    },
    {
        name: 'presidential_sum',
        operators: integerOperators.concat(nullOperators),
        basket: null,
        component: IntRule,
        desc: 'number of Presidential donations (unique by candidate)',
    },
    {
        name: 'reason_to_give',
        operators: containsOperators.concat(nullOperators),
        basket: null,
        component: TextRule,
        desc: 'donors topissues (see top issue tab)',
    },
    {
        name: 'recurring_donation_count',
        operators: integerOperators.concat(nullOperators),
        basket: null,
        component: IntRule,
        desc: 'number of recurring donations made',
    },
    {
        name: 'recurring',
        operators: onlyEqualsOperator.concat(nullOperators),
        basket: null,
        component: BoolRule,
        desc: 'a person has signed up to give a recurring gift to some candidate',
    },
    {
        name: 'republican_sum',
        operators: integerOperators.concat(nullOperators),
        basket: null,
        component: IntRule,
        desc: 'number of donations to gop',
    },
    {
        name: 'risk_ratio',
        operators: integerOperators.concat(nullOperators),
        basket: null,
        component: FloatRule,
        desc: 'The ratio of unsubscribes to clicks, capped at 10. If clicks are 0 but there are unsubs, it forces 10 (max risk). If both are 0/null, it defaults to 1 (neutral). If risk_ratio > 1, the user unsubs more often than they click. If risk_ratio < 1, the user clicks more often than they unsub.',
    },
    {
        name: 'runoff_contributions',
        operators: integerOperators.concat(nullOperators),
        basket: null,
        component: IntRule,
        desc: 'number of contributions to races in a runoff',
    },
    {
        name: 'rural_count',
        operators: integerOperators.concat(nullOperators),
        basket: null,
        component: IntRule,
        desc: 'number of donations made to rural districts',
    },
    {
        name: 'rural_house_count',
        operators: integerOperators.concat(nullOperators),
        basket: null,
        component: IntRule,
        desc: 'number of donations made to rural House districts',
    },
    {
        name: 'seditionist_opp',
        operators: integerOperators.concat(nullOperators),
        basket: null,
        component: IntRule,
        desc: 'Count of donations towards opponents of seditionists. It combines two conditions: they donated to a candidate who is flagged as a sedition opponent, and they made a donation between January 6th-13th, 2021 or on January 6th of any year from 2021 onwards.',
    },
    {
        name: 'senate_cand_string',
        operators: containsOperators.concat(nullOperators),
        basket: null,
        component: TextRule,
        desc: 'lowercase Senate donations',
    },
    {
        name: 'senate_contribution_avg',
        operators: integerOperators.concat(nullOperators),
        basket: null,
        component: FloatRule,
        desc: 'average Senate contribution size',
    },
    {
        name: 'senate_contribution_max',
        operators: integerOperators.concat(nullOperators),
        basket: null,
        component: FloatRule,
        desc: 'highest contribution to a Senate race',
    },
    {
        name: 'senate_multistate_sum',
        operators: integerOperators.concat(nullOperators),
        basket: null,
        component: FloatRule,
        desc: 'number of different states a donor has given to a state-level candidate in',
    },
    {
        name: 'senate_sum',
        operators: integerOperators.concat(nullOperators),
        basket: null,
        component: IntRule,
        desc: 'number of Senate donations (unique by candidate)',
    },
    {
        name: 'shares_email',
        operators: integerOperators.concat(nullOperators),
        basket: null,
        component: IntRule,
        desc: 'tw number of times an email has been sold',
    },
    {
        name: 'shares_email_30d',
        operators: integerOperators.concat(nullOperators),
        basket: null,
        component: IntRule,
        desc: 'number of times an email has been sold in the past 30 days',
    },
    {
        name: 'shares_mobile',
        operators: integerOperators.concat(nullOperators),
        basket: null,
        component: IntRule,
        desc: 'how many times have we shared a persons mobile number',
    },
    {
        name: 'simple_dem',
        operators: stringOperators.concat(nullOperators),
        basket: null,
        component: TextRule,
        desc: 'brief version',
    },
    {
        name: 'sl_topissue',
        operators: integerOperators,
        basket: null,
        component: FloatRule,
        desc: 'topissue derived from subject lines clicked on',
    },
    {
        name: 'state_leg_sum',
        operators: integerOperators.concat(nullOperators),
        basket: null,
        component: IntRule,
        desc: 'number of donations to state leg candidates',
    },
    {
        name: 'state_sum',
        operators: integerOperators.concat(nullOperators),
        basket: null,
        component: IntRule,
        desc: 'number of candidate states that a donor has given in',
    },
    {
        name: 'state',
        operators: inOperator.concat(nullOperators),
        basket: null,
        component: StateRule,
        desc: 'all caps state initials (NY)',
    },
    {
        name: 'statewide_cand_string',
        operators: containsOperators.concat(nullOperators),
        basket: null,
        component: TextRule,
        desc: 'uppercase state-level donations',
    },
    {
        name: 'statewide_contribution_avg',
        operators: integerOperators.concat(nullOperators),
        basket: null,
        component: FloatRule,
        desc: 'average State-level contribution size',
    },
    {
        name: 'statewide_contribution_max',
        operators: integerOperators.concat(nullOperators),
        basket: null,
        component: FloatRule,
        desc: 'highest contribution to a State-level race',
    },
    {
        name: 'statewide_multistate_sum',
        operators: integerOperators.concat(nullOperators),
        basket: null,
        component: FloatRule,
        desc: 'number of different states a donor has given to a state-level candidate in',
    },
    {
        name: 'statewide_sum',
        operators: integerOperators.concat(nullOperators),
        basket: null,
        component: IntRule,
        desc: 'number of statewide donations',
    },
    {
        name: 'suburban_count',
        operators: integerOperators.concat(nullOperators),
        basket: null,
        component: IntRule,
        desc: 'number of donations made to suburban districts',
    },
    {
        name: 'suburban_house_count',
        operators: integerOperators.concat(nullOperators),
        basket: null,
        component: IntRule,
        desc: 'number of donations made to suburban House districts',
    },
    {
        name: 'sum_pvi',
        operators: integerOperators.concat(nullOperators),
        basket: null,
        component: IntRule,
        desc: 'number of donations made to deep red districts',
    },
    {
        name: 'sum_safe_seat',
        operators: integerOperators.concat(nullOperators),
        basket: null,
        component: IntRule,
        desc: 'number of donations made to safe blue seats',
    },
    {
        name: 'tagged_text_donation_average',
        operators: integerOperators.concat(nullOperators),
        basket: null,
        component: FloatRule,
        desc: 'Average donation made in response to a known text with a refcode',
    },
    {
        name: 'timezone',
        operators: inOperator.concat(nullOperators),
        basket: null,
        component: TimezoneRule,
        desc: 'US standard timezone',
    },
    {
        name: 'top_donor_state',
        operators: inOperator.concat(nullOperators),
        basket: null,
        component: StateRule,
        desc: 'Donor top state formatted in all caps (e.g. NY)',
    },
    {
        name: 'topissue',
        operators: inOperator,
        basket: null,
        component: TopIssueRule,
        desc: 'topissue derived from donation history',
    },
    {
        name: 'tw_digital_ad_conversion',
        operators: integerOperators.concat(nullOperators),
        basket: null,
        component: FloatRule,
        desc: 'how many digital ad conversions in the past year',
    },
    {
        name: 'tw_email_conversions',
        operators: integerOperators.concat(nullOperators),
        basket: null,
        component: FloatRule,
        desc: 'how many email conversions in the past year',
    },
    {
        name: 'tw_mobile_conversions',
        operators: integerOperators.concat(nullOperators),
        basket: null,
        component: FloatRule,
        desc: 'time weighted mobile donations',
    },
    {
        name: 'tw_modeled_mail_conversion',
        operators: integerOperators.concat(nullOperators),
        basket: null,
        component: FloatRule,
        desc: 'time weighted modeled mail conversions',
    },
    {
        name: 'twitter_handle',
        operators: stringOperators.concat(nullOperators),
        basket: null,
        component: TextRule,
        desc: "twitter handle. include '@' if using equality operators ('=', '!=')",
    },
    {
        name: 'txt_topissue',
        operators: integerOperators,
        basket: null,
        component: FloatRule,
        desc: 'topissue derrived rom content of texts a person engaged with',
    },
    {
        name: 'unlimited_recurring',
        operators: onlyEqualsOperator.concat(nullOperators),
        basket: null,
        component: BoolRule,
        desc: 'signed up for unlimited recurring gifts on ActBlue',
    },
    {
        name: 'urban_count',
        operators: integerOperators.concat(nullOperators),
        basket: null,
        component: IntRule,
        desc: 'number of donations made to urban districts',
    },
    {
        name: 'urban_house_count',
        operators: integerOperators.concat(nullOperators),
        basket: null,
        component: IntRule,
        desc: 'number of donations made to urban House districts',
    },
    {
        name: 'sms_count',
        operators: integerOperators.concat(nullOperators),
        basket: null,
        component: IntRule,
        desc: 'number of SMS messages donated to',
    },
    {
        name: 'mms_count',
        operators: integerOperators.concat(nullOperators),
        basket: null,
        component: IntRule,
        desc: 'number of MMS messages donated to',
    },
    {
        name: 'p2p_text_count_30d',
        operators: integerOperators.concat(nullOperators),
        basket: null,
        component: IntRule,
        desc: 'number of P2P text messages sent in the past 30 day',
    },
    {
        name: 'used_to_live',
        operators: stringOperators.concat(nullOperators),
        basket: null,
        component: TextRule,
        desc: 'previous city + state (crystal city, VA)',
    },
    {
        name: 'used_to_work',
        operators: stringOperators.concat(nullOperators),
        basket: null,
        component: TextRule,
        desc: 'previous employer (olive garden)',
    },
    {
        name: 'vbvoterbase_mover_status',
        operators: containsOperators.concat(nullOperators),
        basket: null,
        component: TextRule,
        desc: 'categorical variable which indicates if someone lives at the listed address',
    },
    { name: 'work', operators: nullOperators, basket: null, component: TextRule, desc: 'work phone number' },
    {
        name: 'years_in_db',
        operators: integerOperators.concat(nullOperators),
        basket: null,
        component: FloatRule,
        desc: 'how many years have we had this person in the Database',
    },
    {
        name: 'zip',
        operators: equalityOperators.concat(nullOperators),
        basket: null,
        component: TextRule,
        desc: 'five digit zip code (13662)',
    },
];

export const SortByOptions = [
    { name: 'Ask ↓ then Average Give Per Cycle ↓', key: 'STAN' },
    { name: 'Randomly Sorted', key: 'RAND' },
    { name: 'Ask ↓', key: 'P2PSTAN' },
    { name: 'House Multistate Sum ↓', key: 'HOUSEMULTISTATESUM' },
    { name: 'Net-worth Sum ↓', key: 'NETWORTH' },
    { name: 'Active Email Rank ↑', key: 'ACTIVE_EMAIL_RANK' },
    { name: 'Active Mail Rank ↑', key: 'ACTIVE_MAIL_RANK' },
    { name: 'Active Mobile Rank ↑', key: 'ACTIVE_MOBILE_RANK' },
    { name: 'Active Messenger Rank ↑', key: 'ACTIVE_MESSENGER_RANK' },
    { name: 'Active Nonprofit Mobile Rank ↑', key: 'ACTIVE_NONPROFIT_MOBILE_RANK' },
];

export const AggregateOptions = [
    { name: 'Group All', key: 'GA' },
    { name: 'Group By State', key: 'GS' },
    { name: 'Group By County', key: 'GC' },
];

export const DatabaseOptions = [
    { name: 'Production Data', value: 0, roles: ['admin', 'analyst', ''] },
    { name: 'Legacy Data', value: 1, roles: ['admin', 'analyst'] },
    { name: 'Staging Production', value: 2, roles: ['admin'] },
    { name: 'Staging Legacy', value: 3, roles: ['admin'] },
    { name: 'Dev Nadine', value: 4, roles: ['admin'] },
    { name: 'Dev Stephen', value: 6, roles: ['admin'] },
    { name: 'Dev Ro', value: 7, roles: ['admin'] },
    { name: 'Dev Sadie', value: 8, roles: ['admin'] },
    { name: 'Dev Elliot', value: 9, roles: ['admin'] },
];

export const HashTypes = ['MD5', 'MD5_PHONE', 'SHA256', 'SHA256_PHONE'];
